import { gql } from '@apollo/client';

export interface CustomRoleIDInput {
  id: string;
}

export type DeleteCustomRoleResponse = {
  deleteCustomRole: {
    message: string;
  };
};

export const DELETE_CUSTOM_ROLE = gql`
  mutation deleteCustomRole($input: CustomRoleIDInput!) {
    deleteCustomRole(input: $input) {
      message
    }
  }
`;
